import { Component, output } from '@angular/core';
import { RidButton } from '../rid-button/rid-button';

@Component({
  selector: 'rid-instruction-modal',
  imports: [RidButton],
  templateUrl: './rid-instruction-modal.html',
  host: {
    class: 'absolute',
    'animate.enter': 'anim-pop-in',
    'animate.leave': 'anim-pop-out',
  },
})
export class RidInstructionModal {
  started = output<void>();
}
